
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-payments",
      function () {
        return require("private-next-pages/whatsapp-payments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-payments"])
      });
    }
  